module.exports = __webpack_public_path__ + "img/RatBNB3.fbb34b7a.png";